import { selectorActions } from '../../services';

export const pinnedItemDispatcher = dispatch => ( {
  setPinnedItem: ( group, variable, value ) => dispatch( { type: selectorActions.PINITEM, group, variable, value } ),
  removePinnedItem: ( group, variable, value ) => dispatch( { type: selectorActions.UNPINITEM, group, variable, value } ),
  deletePinnedItems: ( group ) => dispatch( { type: selectorActions.REMOVEPINNEDITEMS, group } ),
  removePinnedFilter: (group,variable) => dispatch( { type: selectorActions.REMOVEPINNEDFILTER, group, variable } )
} );